import { actions, Partner } from "@kanda-libs/ks-frontend-services";
import { useAppDispatch } from "components/shared/App";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectors } from "store";

export interface PartnerHook {
  referrer?: Partner;
}

export default function usePartner(): PartnerHook {
  const dispatch = useAppDispatch();
  const company = useSelector(selectors.company.getEntity);
  const partners = useSelector(selectors.partner.getEntities);

  const referredBy = company?.referred_by;

  const referrer = partners[referredBy || ""];

  useEffect(() => {
    if (referredBy && !referrer) {
      dispatch(
        actions.getPartner({
          params: {
            id: referredBy,
          },
        })
      );
    }
  }, [referredBy, referrer]);

  return {
    referrer,
  };
}
